// stores/device.js
import { defineStore } from 'pinia';

export const useDeviceStore = defineStore('device', {
  state: () => ({
    type: 'mobile'
  }),
  actions: {
    update() {
      if (typeof window !== 'undefined') {
        this.type = window.innerWidth > 768 ? 'desktop' : 'mobile';
      }
    }
  }
});